<template lang='pug'>
  .fp-modal-confirm
    h3(v-if='title') {{ title | translate }}
    .content(v-if='content') {{ content | translate }}
    .button-wrapper
      .button-container
        fpui-button(
          type='button',
          color='red',
          reverse,
          @click='handler(buttons[0])'
          icon="fpui fpui-remove",
          icon-left
        ) {{ buttons[0].text | translate }}
        fpui-button(
          type='button',
          color='blue',
          reverse,
          @click='handler(buttons[1])'
          icon="fpui fpui-check",
          icon-left
        ) {{ buttons[1].text | translate }}
</template>

<script>
export default {
  props: {
    content: { type: String },
    title: { type: String },
    buttons: { type: Array, required: true }
  },
  methods: {
    handler (button) {
      this.$emit('close')
      button.handler()
    }
  }
}
</script>

<style lang='less'>
  .fp-modal-confirm {
    position: relative;
    padding: 20px;
    height: 100%;
    h3 {
      width: 100%;
      font-weight: 400!important;
      font-size: 25px !important;
      margin: 0 0 30px 0;
    }
    .content {
      color: #979797;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 300;
      line-height: 22px;
      font-family: 'Source Sans Pro', sans-serif;
    }
    .button-wrapper {
      height: 40px;
      width: 100%;
      .button-container {
        position: absolute;
        right: 0;
        bottom: 15px;
        display: flex;
        align-items: center;
        .fpui-button {
          display: flex;
          align-items: flex-start;
          text-align: center;
          margin-right: 15px;
          padding: 6px 10px 6px 3px;
          .fpui {
            font-size: 25px;
            margin-top: -8px;
            margin-right: -8px;
          }
        }
      }
    }
  }
</style>
